// React
import React from "react";

// Third party imports
import IconButton from "@mui/material/IconButton";

import { useTranslation } from "react-i18next";

import HeaderNavigationTabs from "components/HeaderNavigationTabs";
// Components
import { NotificationsIcon, ReadNotificationIcon, SettingsIcon } from "components/ui/icons";

const NotificationHeader = ({ activeTab, onTabChange, onMarkAllAsRead, onSettingsClick }) => {
  const { t } = useTranslation();

  const tabs = [
    {
      name: t("notificationPopover:unread", "Unread"),
      value: "unread",
      icon: <NotificationsIcon className="w-5 h-5" width={20} height={20} color="currentColor" />,
    },
    {
      name: t("notificationPopover:read", "Read"),
      value: "read",
      icon: <ReadNotificationIcon className="w-5 h-5" />,
    },
  ];

  const handleTabChange = (newValue, tab) => {
    const tabIndex = tabs.findIndex((t) => t.value === tab.value);
    onTabChange(tabIndex);
  };

  return (
    <div className="flex flex-col">
      <HeaderNavigationTabs
        inline
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      <div className="px-2 w-full flex justify-between items-center">
        {activeTab === 0 ? (
          <button
            onClick={onMarkAllAsRead}
            className="my-2 w-fit cursor-pointer rounded-lg border border-gray-200 bg-white px-3 py-2
             text-center text-sm font-medium text-gray-900 transition-colors
             hover:border-gray-300 hover:bg-gray-50
             focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
          >
            {t("notificationPopover:markAllAsRead", "Mark all as read")}
          </button>
        ) : (
          <div className="flex-1 w-full"></div>
        )}
        <IconButton
          size="small"
          aria-label={t("notifications:notifications.settingsAriaLabel")}
          onClick={onSettingsClick}
        >
          <SettingsIcon />
        </IconButton>
      </div>
    </div>
  );
};

export default NotificationHeader;
